angular.module('storefrontApp')
    .component('vcAddress', {
        templateUrl: 'themes/assets/js/common-components/address.tpl.html',
        bindings: {
            address: '=',
            addresses: '<',
            countries: '=',
            validationContainer: '=',
            getCountryRegions: '&',
            editMode: '<',
            onUpdate: '&',
            disabled: '=',
            skipEmail: '<',
        },
        controller: ['$scope', function ($scope) {
            const ctrl = this;

            // Per-instance suffix for the three selects below, which carry hand-written
            // ids rather than going through <vc-labeled-input>. The shipping and
            // billing address forms render together on the checkout payment step
            // (cart.liquid:228 keeps the shipping section in the DOM), so a bare
            // id would make both labels resolve to the shipping select (WCAG 4.1.2).
            ctrl.uid = $scope.$id;

            this.$onInit = function () {
                if (ctrl.validationContainer) {
                    ctrl.validationContainer.addComponent(this);
                }
            };

            this.$onDestroy = function () {
                if (ctrl.validationContainer) {
                    ctrl.validationContainer.removeComponent(this);
                }
            };

            function populateRegionalDataForAddress(address) {
                if (address) {
                    // Set country object for address
                    address.country = _.findWhere(ctrl.countries, {
                        code3: address.countryCode,
                    });
                    if (address.country != null) {
                        ctrl.address.countryName = ctrl.address.country.name;
                        ctrl.address.countryCode = ctrl.address.country.code3;
                    }

                    if (address.country) {
                        if (address.country.regions) {
                            setAddressRegion(address, address.country.regions);
                        } else {
                            ctrl.getCountryRegions({
                                country: address.country,
                            })
                                .then(function (regions) {
                                    address.country.regions = regions;
                                    setAddressRegion(address, regions);
                                });
                        }
                    }
                }
            }

            function setAddressRegion(address, regions) {
                address.region = _.findWhere(regions, {
                    code: address.regionId,
                });
                if (address.region) {
                    ctrl.address.regionId = ctrl.address.region.code;
                    ctrl.address.regionName = ctrl.address.region.name;
                } else {
                    ctrl.address.regionId = undefined;
                    ctrl.address.regionName = undefined;
                }
            }

            ctrl.setForm = function (frm) {
                ctrl.form = frm;
            };

            ctrl.validate = function () {
                if (ctrl.form) {
                    ctrl.form.$setSubmitted();

                    return ctrl.form.$valid;
                }
                return true;
            };

            function stringifyAddress(address) {
                let stringifiedAddress = address.firstName + ' ' + address.lastName + '<br/>';
                stringifiedAddress += address.organization ? address.organization + '<br/>' : '';
                stringifiedAddress += address.line1 + ', ';
                stringifiedAddress += address.line2 ? address.line2 + '<br/>' : '';
                stringifiedAddress += address.city + ', ';
                stringifiedAddress += address.regionName ? address.regionName + ', ' : '';
                stringifiedAddress += address.postalCode + '<br/>';
                stringifiedAddress += address.countryName;

                return stringifiedAddress;
            }

            $scope.$watchCollection('$ctrl.address', function () {
                if (ctrl.countries && ctrl.countries.length > 0 && ctrl.address && !ctrl.address.countryCode) {
                    ctrl.address.countryCode = ctrl.countries[0].code3;
                }

                if (ctrl.address) {
                    populateRegionalDataForAddress(ctrl.address);
                    ctrl.address.name = stringifyAddress(ctrl.address);
                }
                ctrl.onUpdate({
                    address: ctrl.address,
                });
            });
        }],
    });
